import './css/Home.css'
import Slider from './Slider'
import Movies from './Movies'

export default function Home() {
    return (
        <div id="home">
            <Slider />
            <Movies />
        </div>
    )
}

